/**
 * ScrollToTop — mounts inside <Router>, listens to route changes,
 * and scrolls the window to the top on every navigation.
 *
 * Usage in App.js:
 *   import ScrollToTop from "./components/ScrollToTop";
 *   <Router>
 *     <ScrollToTop />
 *     <Routes>...</Routes>
 *   </Router>
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}
